import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "components/app/dialog/dialog";

import { useEffect, useRef, useState } from "react";
import { SendHorizontalIcon, Sticker, X } from "lucide-react";

import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useInView } from "react-intersection-observer";

import { faFaceSmileBeam } from "@fortawesome/free-solid-svg-icons";

import Comment from "pages/profile-post-contents-page-view/post-component/Comment";
import { ScrollArea } from "components/ui/scroll-area";
import { Service } from "utils/services";
import { Textarea } from "components/ui/textarea";
import EmojiPicker, { EmojiClickData, EmojiStyle } from "emoji-picker-react";
import StickerPicker from "pages/profile-post-contents-page-view/post-component/Stickers";
import useFollowingStore from "store/useFollowingStore";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";

interface DialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}

export default function DialogFollowingComment({
  isDialogOpen,
  setIsDialogOpen,
}: DialogProps) {
  const { ref: inViewRef, inView } = useInView({ threshold: 0.6 });

  const {
    comments,
    commentAppRecord,
    requestSubmitComment,
    fetchComments,
    requestReplyComment,
    fetchSubComments,
    requestReactionComment,
  } = useFollowingStore();

  // * ==== Comment ==== * //
  const [replyingTo, setReplyingTo] = useState<number | null>(null);
  const [textComment, setTextComment] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef<HTMLDivElement>(null);
  const [sticker, setSticker] = useState<any>({});
  const [showStickerPicker, setShowStickerPicker] = useState(false);
  const stickerPickerRef = useRef<HTMLDivElement>(null);

  // * ==== Comment ==== * //

  const handleReplyClick = (commentId: number) => {
    setReplyingTo(commentId);
  };

  const onHandleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (textComment) {
        requestSubmitComment(sticker, textComment);
        setTextComment("");
        setSticker({});
      }
    }
  };

  const onEmojiClick = (emojiData: EmojiClickData) => {
    setTextComment((prev) => prev + emojiData.emoji);
    // setShowEmojiPicker(false);
  };

  useEffect(() => {
    if (inView && commentAppRecord.canLoadMore()) {
      fetchComments(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent
        isShowBtnXClose={false}
        className="max-w-full lg:max-w-[700px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col"
        onWheelCapture={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle></DialogTitle>

          <div
            className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>

        <ScrollArea className="flex-1 items-center">
          <div className=" px-3 pb-1 rounded-lg  mb-4 w-full ">
            <div></div>
          </div>

          <div className="space-y-2 px-2">
            {[...comments].map((comment, index) => (
              <Comment
                replyingTo={replyingTo!}
                onReplyClick={() => handleReplyClick(comment.id)}
                key={comment.id}
                comment={comment}
                index={index}
                submitReply={(data: any) => {
                  requestReplyComment(data);
                  handleReplyClick(-1);
                }}
                onClikcReact={() => requestReactionComment({ comment })}
                fetchSubComments={fetchSubComments}
              >
                {comment.sub_comments?.data?.length > 0 && (
                  <div className="">
                    {comment.sub_comments.data.map(
                      (subComment: any, subIndex: number) => (
                        <Comment
                          replyingTo={replyingTo!}
                          onReplyClick={() => handleReplyClick(subComment.id)}
                          key={subComment.id}
                          comment={subComment}
                          index={subIndex}
                          submitReply={(data: any) => {
                            requestReplyComment(data);
                            handleReplyClick(-1);
                          }}
                          onClikcReact={() =>
                            requestReactionComment({
                              comment: subComment,
                            })
                          }
                          fetchSubComments={fetchSubComments}
                          isSubComment={true}
                        >
                          {/* Recursively render deeper sub-comments */}
                          {subComment.sub_comments?.data?.length > 0 && (
                            <div className="">
                              {subComment.sub_comments.data.map(
                                (nestedComment: any, nestedIndex: number) => (
                                  <Comment
                                    replyingTo={replyingTo!}
                                    onReplyClick={() =>
                                      handleReplyClick(nestedComment.id)
                                    }
                                    key={nestedComment.id}
                                    comment={nestedComment}
                                    index={nestedIndex}
                                    submitReply={(data: any) => {
                                      requestReplyComment(data);
                                      handleReplyClick(-1);
                                    }}
                                    onClikcReact={() =>
                                      requestReactionComment({
                                        comment: nestedComment,
                                      })
                                    }
                                    fetchSubComments={fetchSubComments}
                                    isSubComment={true}
                                  >
                                    {nestedComment.sub_comments?.data?.length >
                                      0 && (
                                      <div className="">
                                        {nestedComment.sub_comments.data.map(
                                          (
                                            nestedComment_f: any,
                                            nestedIndex_f: number
                                          ) => (
                                            <Comment
                                              replyingTo={replyingTo!}
                                              onReplyClick={() =>
                                                handleReplyClick(
                                                  nestedComment_f.id
                                                )
                                              }
                                              key={nestedComment_f.id}
                                              comment={nestedComment_f}
                                              index={nestedIndex_f}
                                              submitReply={(data: any) => {
                                                requestReplyComment(data);
                                                handleReplyClick(-1);
                                              }}
                                              onClikcReact={() =>
                                                requestReactionComment({
                                                  comment: nestedComment_f,
                                                })
                                              }
                                              isSubComment={true}
                                            />
                                          )
                                        )}
                                      </div>
                                    )}
                                  </Comment>
                                )
                              )}
                            </div>
                          )}
                        </Comment>
                      )
                    )}
                  </div>
                )}
              </Comment>
            ))}

            <div
              ref={inViewRef}
              className="h-10 flex justify-center items-center"
            ></div>
          </div>
        </ScrollArea>

        {/* <div className="flex flex-row  dark:bg-background  justify-center items-start space-x-2 w-full pt-2 mt-4 px-4">
          <ImageUrlProfile
            isLinkProfile={true}
            user={Service?.userAuth}
            className="cursor-pointer rounded-full w-7 h-7"
            alt="logo"
          />
          <div className="flex flex-col space-y-2  w-full items-start justify-start">
            <div className="border  relative p-2 rounded-2xl w-full dark:bg-[#3A3B3C] ">
              <div className="flex flex-col">
                <Textarea
                  value={textComment}
                  onKeyDown={onHandleKeyDown}
                  maxLength={100}
                  onChange={(e) => setTextComment(e.target.value)}
                  className="border border-none min-h-[10px]  focus-visible:ring-0 focus-visible:ring-offset-0 w-full  px-0 py-0 rounded-none dark:bg-[#3A3B3C]"
                  placeholder="Add comment"
                />
                <div className="flex justify-between items-center">
                  <div className="flex space-x-2 items-center">
                    <FontAwesomeIcon
                      icon={faFaceSmileBeam}
                      className="text-gray-500 dark:text-gray-300 cursor-pointer size-4"
                      onClick={() => setShowEmojiPicker((prev) => !prev)}
                    />

                    <Sticker
                      className=" text-gray-700 dark:text-gray-300 w-5 h-5 font-extrabold cursor-pointer"
                      onClick={() => setShowStickerPicker((prev) => !prev)}
                    />
                  </div>
                  {showStickerPicker && (
                    <div
                      ref={emojiPickerRef}
                      className={`absolute bottom-[50px] left-0 `}
                      spellCheck={false}
                    >
                      <StickerPicker
                        stickerPickerRef={stickerPickerRef}
                        onStickerSelect={(sticker) => {
                          setShowStickerPicker((prev) => !prev);
                          setSticker(sticker);
                        }}
                      />
                    </div>
                  )}
                  {showEmojiPicker && (
                    <div
                      ref={emojiPickerRef}
                      className={`absolute bottom-[50px] left-0 `}
                      spellCheck={false}
                    >
                      <EmojiPicker
                        reactionsDefaultOpen={false}
                        onEmojiClick={onEmojiClick}
                        emojiStyle={EmojiStyle.FACEBOOK}
                        searchDisabled={true}
                        skinTonesDisabled={true}
                      />
                    </div>
                  )}
                  <SendHorizontalIcon
                    className={`cursor-pointer ${
                      textComment || Object.keys(sticker).length !== 0
                        ? "text-yellow-400"
                        : "text-gray-500 dark:text-gray-300"
                    }`}
                    onClick={
                      !textComment && Object.keys(sticker).length === 0
                        ? () => {}
                        : () => {
                            requestSubmitComment(sticker, textComment);
                            setTextComment("");
                            setSticker({});
                          }
                    }
                  />
                </div>
              </div>
            </div>
            {Object.keys(sticker).length !== 0 ? (
              <div className="relative sticker-image w-16 h-16">
                <img src={sticker.thumbnail_url} alt={sticker.pack_name} />
                <div
                  className="absolute bg-gray-200 hover:bg-gray-300 -top-1 -right-2 w-5 h-5 rounded-full dark:bg-[#3A3B3C] flex items-center cursor-pointer justify-center hover:dark:bg-[#4E4F50]"
                  onClick={() => setSticker({})}
                >
                  <X className="w-4 h-4 " />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div> */}
        <div className="flex flex-row  dark:bg-background  justify-center items-start space-x-2 w-full  ">
          <ImageUrlProfile
            isLinkProfile={true}
            user={Service?.userAuth}
            className="cursor-pointer rounded-full w-7 h-7"
            alt="logo"
          />
          <div className="flex flex-col space-y-2  w-full items-start justify-start">
            <div className="border p-2 rounded-2xl w-full dark:bg-[#3A3B3C] ">
              <div className="flex flex-col">
                <Textarea
                  value={textComment}
                  onKeyDown={onHandleKeyDown}
                  maxLength={100}
                  onChange={(e) => setTextComment(e.target.value)}
                  className="border border-none min-h-[10px]  focus-visible:ring-0 focus-visible:ring-offset-0 w-full  px-0 py-0 rounded-none dark:bg-[#3A3B3C]"
                  placeholder="Add comment"
                />

                {/*------ new code ----- */}

                <div className="flex justify-between items-center">
                  <div className="flex space-x-2 items-center">
                    <Popover>
                      <PopoverTrigger asChild>
                        <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                          <FontAwesomeIcon
                            icon={faFaceSmileBeam}
                            className="text-gray-500 dark:text-gray-500 cursor-pointer size-5"
                            onClick={() => setShowEmojiPicker((prev) => !prev)}
                          />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent className="w-92 bg-transparent border-none shadow-none">
                        <EmojiPicker
                          reactionsDefaultOpen={false}
                          onEmojiClick={onEmojiClick}
                          emojiStyle={EmojiStyle.FACEBOOK}
                          searchDisabled={true}
                          skinTonesDisabled={true}
                        />
                      </PopoverContent>
                    </Popover>
                    <Popover>
                      <PopoverTrigger asChild>
                        <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center">
                          <Sticker
                            className=" text-gray-700 dark:text-gray-500 size-5 font-extrabold cursor-pointer"
                            onClick={() => setShowStickerPicker(true)}
                          />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent className="w-92 bg-transparent border-none shadow-none">
                        {showStickerPicker && (
                          <StickerPicker
                            stickerPickerRef={stickerPickerRef}
                            onStickerSelect={(sticker) => {
                              setShowStickerPicker(false);
                              setSticker(sticker);
                            }}
                          />
                        )}
                      </PopoverContent>
                    </Popover>
                  </div>
                  <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center ">
                    <SendHorizontalIcon
                      className={`cursor-pointer size-5 ${
                        textComment || Object.keys(sticker).length !== 0
                          ? "text-yellow-400"
                          : "text-gray-500 dark:text-gray-500"
                      }`}
                      onClick={
                        !textComment && Object.keys(sticker).length === 0
                          ? () => {}
                          : () => {
                              requestSubmitComment(sticker, textComment);
                              setTextComment("");
                              setSticker({});
                            }
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {Object.keys(sticker).length !== 0 ? (
              <div className="relative sticker-image w-16 h-16">
                <img src={sticker.thumbnail_url} alt={sticker.pack_name} />
                <div
                  className="absolute bg-gray-200 hover:bg-gray-300 -top-1 -right-2 w-5 h-5 rounded-full dark:bg-[#3A3B3C] flex items-center cursor-pointer justify-center hover:dark:bg-[#4E4F50]"
                  onClick={() => setSticker({})}
                >
                  <X className="w-4 h-4 " />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

